import axios from 'axios';
import { API_URL } from 'configs'

export const EMAIL_SCHEDULER_REQUEST = 'EMAIL_SCHEDULER_REQUEST'
export const EMAIL_SCHEDULER_SUCCES = 'EMAIL_SCHEDULER_SUCCES'
export const EMAIL_SCHEDULER_VALIDATION_ERROR = 'EMAIL_SCHEDULER_VALIDATION_ERROR'
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_EMAIL_SCHEDULER_FEILD_VALIDATION_ERROR = "HIDE_EMAIL_SCHEDULER_FEILD_VALIDATION_ERROR"
export const REDIRECT_TO_EMAIL_SCHEDULER_LIST = 'REDIRECT_TO_EMAIL_SCHEDULER_LIST'
export const EMAIL_SCHEDULER_GET_SUCCESS = 'EMAIL_SCHEDULER_GET_SUCCESS'
export const EMAIL_SCHEDULER_SERVER_SUCCESS = 'EMAIL_SCHEDULER_SERVER_SUCCESS'
const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';

const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
})
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
})

const emailReportSetupRequest = () => ({
  type: EMAIL_SCHEDULER_REQUEST,
})

export const emailSchedulerServerListSuccess = () => ({
  type:EMAIL_SCHEDULER_SERVER_SUCCESS,
})

const emailSchedulerListSuccess = emailSchedulerList => ({
  type:EMAIL_SCHEDULER_SUCCES,
  emailSchedulerList: emailSchedulerList,
})

const emailSchedulerFailure = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
})
const validationError = notification => ({
  type:EMAIL_SCHEDULER_VALIDATION_ERROR,
  validation_error: notification,
})
const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
})

const emailSchedulerAddUpdateSuccess = (message, action, dispatch) => {
  dispatch(emailSchedulerSuccessNotification(message))
  dispatch(redirectToEmailSchedulerList())
}

export const redirectToEmailSchedulerList = () => ({
  type: REDIRECT_TO_EMAIL_SCHEDULER_LIST,
})

const getEmailSchedulerSuccess = (response, action) => ({
  type:EMAIL_SCHEDULER_GET_SUCCESS,
  record: response,
  actionType: action
})

const emailSchedulerSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
})


export const hideEmailSchedulerValidationError = (feild_key) => ({
  type: HIDE_EMAIL_SCHEDULER_FEILD_VALIDATION_ERROR,
  feild_key: feild_key
})

export const emailSchedulerListFetch = (object_viewed_id = '') => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(emailReportSetupRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "email_scheduler/getAll", {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      params: {object_viewed_id: object_viewed_id}
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(emailSchedulerListSuccess(response.data))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const getEmailSchedulerById = (id, action) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(emailReportSetupRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "email_scheduler/getById/" + id, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(getEmailSchedulerSuccess(response.data, action))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const addEmailScheduler = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(emailReportSetupRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "email_scheduler/create", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: data,
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        emailSchedulerAddUpdateSuccess('Email Scheduler Added Successfully', 'create', dispatch)
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const updateEmailScheduler = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(emailReportSetupRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "email_scheduler/update/" + data.get('id'), {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
      data: data
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        emailSchedulerAddUpdateSuccess('Email Scheduler Updated Successfully', 'update', dispatch)
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}



export const deleteEmailScheduler = (emailReportSetupId, object_viewed_id) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(emailReportSetupRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "email_scheduler/delete/" + emailReportSetupId, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data:{
        object_viewed_id
      }
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(emailSchedulerSuccessNotification('Email Scheduler deleted successfully'))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });
  }

}

// handling error reponse   
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error))
    }
    else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()))
    }
    else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString()
      }
      else {
        err = error.response.status + ` ` + error.response.statusText
      }
      dispatch(emailSchedulerFailure(err))
    }
  }
  catch (e) {
    dispatch(emailSchedulerFailure('Unable to perform action.Something went wrong'))
  }
}   